import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import {inject} from "@angular/core";
import {getCurrentUser} from '@aws-amplify/auth';

export const authGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  return getCurrentUser().then((user) => {
    return true;
  }).catch((e) => {
    router.navigate(['/auth/sign-in']);
    return false;
  })
};
